import React from "react";
import { Box, Chip, Container, Paper, Stack, Typography } from "@mui/material";
import PointOfSaleRoundedIcon from "@mui/icons-material/PointOfSaleRounded";
import EventAvailableRoundedIcon from "@mui/icons-material/EventAvailableRounded";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

const benefitGroups = [
  {
    icon: PointOfSaleRoundedIcon,
    title: "Ventas y pedidos",
    text: "Seguí lo que se vende y cómo avanza cada operación.",
    examples: ["Productos", "Pedidos", "Cobros", "Estados"],
  },
  {
    icon: EventAvailableRoundedIcon,
    title: "Agenda y clientes",
    text: "Organizá atención, reservas y seguimiento sin perder contexto.",
    examples: ["Turnos", "Reservas", "Clientes", "Agenda"],
  },
  {
    icon: Inventory2OutlinedIcon,
    title: "Control del negocio",
    text: "Revisá stock, actividad y pendientes desde la misma operación.",
    examples: ["Stock", "Actividad", "Alertas", "Seguimiento"],
  },
];

export default function ResponsiveShowcase() {
  return (
    <Box
      id="herramientas"
      component="section"
      aria-labelledby="herramientas-title"
      sx={{
        py: { xs: 5, sm: 7, md: 11 },
        bgcolor: "#F6F8FA",
        scrollMarginTop: 90,
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ maxWidth: 760 }}>
          <Chip
            label="Qué podés gestionar"
            sx={{ bgcolor: "#19242F", color: "#fff", fontWeight: 900 }}
          />
          <Typography
            id="herramientas-title"
            component="h2"
            sx={{
              mt: 2,
              color: "#19242F",
              fontWeight: 950,
              letterSpacing: "-.045em",
              lineHeight: 1.04,
              fontSize: { xs: "1.75rem", sm: "2.35rem", md: "3.45rem" },
            }}
          >
            Lo que pasa después de publicar.
          </Typography>
          <Typography
            sx={{
              mt: { xs: 1, sm: 1.6 },
              maxWidth: 650,
              color: "rgba(25,36,47,.66)",
              lineHeight: { xs: 1.45, sm: 1.6, md: 1.65 },
              fontSize: { xs: ".88rem", md: "1.06rem" },
            }}
          >
            Activá sólo los módulos que correspondan a tu operación y revisalos desde el mismo proyecto.
          </Typography>
        </Box>

        <Box
          sx={{
            mt: { xs: 2.5, sm: 3.5, md: 5.5 },
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "repeat(2, minmax(0, 1fr))", lg: "repeat(3, minmax(0, 1fr))" },
            gap: { xs: 1, sm: 1.5, md: 2 },
          }}
        >
          {benefitGroups.map(({ icon: Icon, title, text, examples }, index) => (
            <Paper
              key={title}
              elevation={0}
              sx={{
                p: { xs: 1.5, sm: 2.5, md: 3 },
                borderRadius: 4,
                border: index === 0
                  ? "1px solid rgba(243,90,58,.2)"
                  : "1px solid rgba(25,36,47,.08)",
                bgcolor: index === 0 ? "#FFF7F3" : "#fff",
                boxShadow: "0 14px 34px rgba(25,36,47,.045)",
                display: "flex",
                flexDirection: "column",
                minHeight: { lg: 270 },
                gridColumn: index === 2 ? { sm: "1 / -1", lg: "auto" } : "auto",
              }}
            >
              <Box
                sx={{
                  width: { xs: 40, sm: 50 },
                  height: { xs: 40, sm: 50 },
                  borderRadius: 3,
                  display: "grid",
                  placeItems: "center",
                  bgcolor: index === 0 ? "#F35A3A" : "rgba(25,36,47,.07)",
                  color: index === 0 ? "#fff" : "#19242F",
                }}
              >
                <Icon />
              </Box>

              <Typography
                sx={{
                  mt: { xs: 1.2, sm: 2.2 },
                  color: "#19242F",
                  fontWeight: 950,
                  fontSize: { xs: "1rem", sm: "1.14rem" },
                  lineHeight: 1.25,
                }}
              >
                {title}
              </Typography>
              <Typography
                sx={{
                  mt: { xs: .55, sm: 1 },
                  color: "rgba(25,36,47,.64)",
                  lineHeight: { xs: 1.4, sm: 1.58 },
                  fontSize: { xs: ".82rem", sm: ".91rem" },
                }}
              >
                {text}
              </Typography>

              <Stack direction="row" flexWrap="wrap" gap={0.8} sx={{ mt: "auto", pt: 2.4, display: { xs: "none", sm: "flex" } }}>
                {examples.map((example) => (
                  <Chip
                    key={example}
                    label={example}
                    size="small"
                    sx={{
                      bgcolor: "rgba(25,36,47,.055)",
                      color: "rgba(25,36,47,.72)",
                      fontWeight: 800,
                      fontSize: ".75rem",
                    }}
                  />
                ))}
              </Stack>
            </Paper>
          ))}
        </Box>

      </Container>
    </Box>
  );
}
